<template>
  <el-button @click="onLinkButtonClick">{{widget.label || widget.id}}</el-button>
</template>

<script>
export default {
    name : 'TicketWidgetLinkButton',

    props : ['widget'],

    methods : {
      onLinkButtonClick() {
        location.href = this.widget.parameter;
      }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/ticket/TicketWidgetLinkButton.vue